{
  "pending": "pendente"
}
